exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-carousel__button {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n.select-goods-box .el-transfer-panel {\n  text-align: left;\n  width: 270px;\n}\n.select-goods-box .el-transfer-panel .el-transfer-panel__body {\n    height: 270px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-b6f9d2ec","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/view/wxapp/template/store/universal.vue
// module id = 1673
// module chunks = 0